<div class="title">
  <div class="mat-subheading-2 ">
      Export this experience for LMS
      <mat-icon (click)="goToHelp('http://help.spaces.wondavr.com/en/articles/2630787-lms-connectors')" class="help-link">help</mat-icon>
  </div>
  <div class="close" (click)="onClose()">
      <mat-icon>clear</mat-icon>
  </div>
</div>

<div  class="dialog-content">
  <div>
    <i>Please select one of the export options. <a href="mailto:support@wondavr.com">Contact us</a> if you have questions about LMS export.</i>
  </div>
  <mat-tab-group vertical id="tab-group">
      <mat-tab label="xAPI" color="white" >
        <div class="learnspace-theme setting-tab" id="lti_tab">
            <form [formGroup]="xAPIForm">
                <div formGroupName="information">
                    <div formGroupName="externalXAPI">
                        <input matInput placeholder="End Point" formControlName="xapi_endpoint">
                        <input matInput placeholder="User" formControlName="xapi_key">
                        <input matInput placeholder="Password" formControlName="xapi_secret">
                    </div>
                </div>
            </form>
            <button mat-raised-button color="primary" (click)="onSave()">Confirm</button>
        </div>
      </mat-tab>
      <mat-tab label="LTI" color="white" class="learnspace-theme  setting-tab">
        <div class="learnspace-theme setting-tab" >
            <div *ngIf="this.ltiEnabled; else ltiMessage" class="url-container">
                <input type="text" name="url" [value]="ltilaunch" readonly (click)="$event.target.select()">
            </div>
            <ng-template #ltiMessage>
              <div id="nolti">You have not enabled the LTI options. Go to the integration tab of your hub settings to activate.</div>
            </ng-template>
        </div>
      </mat-tab>
      <mat-tab label="SCORM" color="white" class="learnspace-theme"  setting-tab>
        <div class="learnspace-theme setting-tab" >
          <a target="_blank" href="{{scormLink}}"> Download</a> this experience as <b>SCORM 2004</b> Package
        </div>
      </mat-tab>
  </mat-tab-group>
</div>